<template>
  <v-card
    :loading="isLoading"
    width="550"
    class="mx-auto mt-16 py-3"
    rounded="lg"
  >
    <div class="d-flex justify-end mb-4 mr-3">
      <v-icon @click="$router.back()">mdi-close</v-icon>
    </div>
    <v-alert
      v-if="isAdmin && converter && converter.is_price_from_stehling"
      outlined
      type="info"
      text
    >
      Price is fetched from Stehling
    </v-alert>
    <v-alert
      v-if="isAdmin && converter && converter.stehling_price_error_message"
      outlined
      type="error"
      text
    >
      {{ converter.stehling_price_error_message }}
    </v-alert>
    <div
      v-if="converter"
      class="px-3 px-md-10"
    >
      <v-row>
        <v-col sm="6" v-if="converter.image">
          <v-img
            @mouseover="imageHovered = true"
            @mouseleave="imageHovered = false;"
            :src="converter.image"
            @click="imageClicked('image')"
          >
            <v-overlay
              :value="imageHovered"
              absolute
            >
              <v-icon>mdi-open-in-new</v-icon>
            </v-overlay>
          </v-img>
        </v-col>
        
        <v-col sm="6" v-if="converter.image_2">
          <v-img
          @mouseover="image2Hovered = true"
          @mouseleave="image2Hovered = false;"
          :src="converter.image_2"
          @click="imageClicked('image_2')"
        >
          <v-overlay
            :value="image2Hovered"
            absolute
          >
            <v-icon>mdi-open-in-new</v-icon>
          </v-overlay>
        </v-img>
        </v-col>
        <v-col sm="6" v-if="converter.image_3">
          <v-img
          @mouseover="image3Hovered = true"
          @mouseleave="image3Hovered = false;"
          :src="converter.image_3"
          @click="imageClicked('image_3')"
        >
          <v-overlay
            :value="image3Hovered"
            absolute
          >
            <v-icon>mdi-open-in-new</v-icon>
          </v-overlay>
        </v-img>
        </v-col>
        <v-col sm="6" v-if="converter.image_4">
          <v-img
          @mouseover="image4Hovered = true"
          @mouseleave="image4Hovered = false;"
          :src="converter.image_4"
          @click="imageClicked('image_4')"
        >
          <v-overlay
            :value="image4Hovered"
            absolute
          >
            <v-icon>mdi-open-in-new</v-icon>
          </v-overlay>
        </v-img>
        </v-col>
      </v-row>

      <v-card-title>{{ converter.code || "" }}</v-card-title>
      <v-card-text>
        <p class="text-body-1">Manufacturer: <span class="font-weight-bold">{{converter.manufacturer || ""}}</span></p>
        <p class="text-body-1">Description: <span class="font-weight-bold">{{converter.description || ""}}</span></p>
        <!-- below is if we are doing composition in a flexible grid
        <div class="d-flex text-body-1 mb-4">
          <div>Composition:</div>
          <div class="flex-grow-1 d-flex flex-wrap ml-2 font-weight-bold">
            <span class="mr-2">Platinum: {{converter.platinum_amount_ounces}} oz</span><span class="mr-2">Platinum: 22 oz</span><span>Platinum: 22 oz</span>
          </div>
        </div> -->
        <template v-if="isAdmin">
          <p class="text-body-1">Platinum: <span class="font-weight-bold">{{converter.platinum_amount_ounces || ""}} oz</span></p>
          <p class="text-body-1">Palladium: <span class="font-weight-bold">{{converter.palladium_amount_ounces || ""}} oz</span></p>
          <p class="text-body-1">Rhodium: <span class="font-weight-bold">{{converter.rhodium_amount_ounces || ""}} oz</span></p>
        </template>
        <p class="text-body-1">Current Price: <span class="font-weight-bold">{{converter.current_price ? '$' + converter.current_price : "Unavailable"}}</span> </p>
      </v-card-text>
      <vehicles-dailog
        :converterId="id"
      ></vehicles-dailog>
      <v-row
        class="mt-0"
        v-if="isAdmin"
      >
        <v-col>
          <v-btn
            block
            color="success"
            :to="{name:'edit-converter', params: {id:converter.id}}"
          >Edit</v-btn>
        </v-col>
        <v-col>
          <v-btn
            block
            color="error"
            @click="deleteClicked"
          >Delete</v-btn>
        </v-col>
      </v-row>
    </div>
    <error-alert :message.sync="error"></error-alert>
  </v-card>
</template>
<script>
import { extractDataAxios, extractErrorMessageAxios } from "@/httpClient";
import { mapActions } from "@/store/modules/catalyticConverters";
import { mapGetters } from "@/store/modules/user";
import VehiclesDailog from "./VehiclesDailog.vue";

export default {
  components: { VehiclesDailog },
  props: ["id"],

  data: () => ({
    isLoading: false,
    converter: null,
    error: null,
    imageHovered: false,
    image2Hovered: false,
    image3Hovered: false,
    image4Hovered: false,
  }),

  created: function () {
    this.fetchData();
  },

  watch: {
    id: "fetchData",
  },

  computed: {
    ...mapGetters(["isAdmin"]),
  },

  methods: {
    ...mapActions({
      delete: "delete",
    }),

    async fetchData() {
      this.isLoading = true;
      this.error = null;
      try {
        const data = extractDataAxios(await window.axios.get("/api/catalytic-converters/" + this.id));
        if (data) {
          this.converter = data;
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.isLoading = false;
        this.error = extractErrorMessageAxios(e);
      }
    },

    imageClicked(whichImage) {
      if (this.converter[whichImage]) {
        window.open(this.converter[whichImage], "_blank").focus();
      }
    },

    deleteClicked() {
      if (window.confirm("Are you sure that you want to delete")) {
        this.delete(this.converter.id);
        // replace the route right away to list
        this.$router.replace("/catalytic-converters");
      }
    },
  },
};
</script>